import { Box, Text, Divider } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

interface StaffControlsWrapperProps {
  children: ReactNode;
  title?: string;
  description?: string;
  showDividers?: boolean;
}

const StaffControlsWrapper = ({
  children,
  title = 'Loma Staff Controls',
  description = 'These controls are only available to Loma staff users.',
  showDividers = true,
}: StaffControlsWrapperProps) => {
  return (
    <>
      {showDividers && <Divider my={2} />}
      <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={4} bg="gray.50">
        <Text fontWeight="bold" mb={2}>
          {title}
        </Text>
        <Text mb={4} fontSize="sm" color="gray.600">
          {description}
        </Text>
        <Divider mb={4} />
        {children}
      </Box>
      {showDividers && <Divider />}
    </>
  );
};

export default StaffControlsWrapper;
